import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ServiceChecklistCategoryEditor.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import MultiLangEdit from '../../../moreCore/UI/MultiLangEdit/MultiLangEdit';

class ServiceChecklistCategoryEditor extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    private sc_Input_Description_MultiLang: MdsLax<InstanceType<typeof MultiLangEdit<any>>>;

    isValid(): boolean {
        let isValid = true;

        isValid = isValid && this.sc_Input_Description_MultiLang.isValid;

        return isValid;
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.ServiceChecklistCategory;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ServiceChecklistCategoryEditor);